/**
 * jQuery No-Op Stub — resilience layer
 *
 * Loaded with defer right after jquery.min.js. If jQuery failed to load
 * (ERR_TIMED_OUT, ERR_CONNECTION_REFUSED, etc.) this provides a minimal
 * no-op shim so that vendors.min.js and main.min.js don't throw
 * ReferenceError and the page degrades gracefully instead of crashing.
 *
 * When jQuery loads successfully this file does nothing.
 */
(function () {
  "use strict";
  if (typeof jQuery !== "undefined") return; // jQuery loaded fine — bail out

  // Chainable no-op object returned by every $() call
  var chainable = { length: 0 };
  var methods = [
    "on",
    "off",
    "one",
    "bind",
    "unbind",
    "delegate",
    "undelegate",
    "find",
    "closest",
    "parent",
    "parents",
    "children",
    "siblings",
    "next",
    "prev",
    "each",
    "map",
    "filter",
    "not",
    "first",
    "last",
    "eq",
    "slice",
    "addClass",
    "removeClass",
    "toggleClass",
    "hasClass",
    "css",
    "attr",
    "removeAttr",
    "prop",
    "removeProp",
    "data",
    "removeData",
    "html",
    "text",
    "val",
    "empty",
    "remove",
    "detach",
    "append",
    "prepend",
    "after",
    "before",
    "wrap",
    "wrapAll",
    "wrapInner",
    "unwrap",
    "clone",
    "replaceWith",
    "replaceAll",
    "show",
    "hide",
    "toggle",
    "fadeIn",
    "fadeOut",
    "fadeToggle",
    "fadeTo",
    "slideUp",
    "slideDown",
    "slideToggle",
    "animate",
    "stop",
    "delay",
    "finish",
    "trigger",
    "triggerHandler",
    "click",
    "dblclick",
    "focus",
    "blur",
    "change",
    "submit",
    "keydown",
    "keyup",
    "keypress",
    "mousedown",
    "mouseup",
    "mousemove",
    "mouseenter",
    "mouseleave",
    "hover",
    "scroll",
    "resize",
    "load",
    "ready",
    "unload",
    "width",
    "height",
    "innerWidth",
    "innerHeight",
    "outerWidth",
    "outerHeight",
    "scrollTop",
    "scrollLeft",
    "offset",
    "position",
    "add",
    "end",
    "andSelf",
    "addBack",
    "contents",
    "index",
    "toArray",
    "get",
    "promise",
  ];
  for (var i = 0; i < methods.length; i++) {
    (function (name) {
      chainable[name] = function () {
        return chainable;
      };
    })(methods[i]);
  }
  // Override a few to return sensible values
  chainable.hasClass = function () {
    return false;
  };
  chainable.width =
    chainable.height =
    chainable.innerWidth =
    chainable.innerHeight =
    chainable.outerWidth =
    chainable.outerHeight =
    chainable.scrollTop =
    chainable.scrollLeft =
    chainable.index =
      function () {
        return 0;
      };
  chainable.offset = chainable.position = function () {
    return { top: 0, left: 0 };
  };
  chainable.html =
    chainable.text =
    chainable.val =
    chainable.attr =
    chainable.data =
    chainable.css =
    chainable.prop =
      function () {
        return arguments.length ? chainable : "";
      };
  chainable.toArray = chainable.get = function () {
    return [];
  };
  chainable.is = function () {
    return false;
  };
  chainable.promise = function () {
    return {
      then: function (fn) {
        if (fn) fn();
        return this;
      },
      done: function (fn) {
        if (fn) fn();
        return this;
      },
      fail: function () {
        return this;
      },
      always: function (fn) {
        if (fn) fn();
        return this;
      },
    };
  };

  // The main $ function
  function jqStub(selector) {
    // $(function) — DOM ready shorthand
    if (typeof selector === "function") {
      if (document.readyState !== "loading") {
        selector(jqStub);
      } else {
        document.addEventListener("DOMContentLoaded", function () {
          selector(jqStub);
        });
      }
      return chainable;
    }
    // $(DOMElement) or $(string)
    return chainable;
  }

  // Static methods
  jqStub.fn = jqStub.prototype = chainable;
  jqStub.extend = function () {
    var target = arguments[0] || {};
    for (var a = 1; a < arguments.length; a++) {
      var src = arguments[a];
      if (src)
        for (var key in src)
          if (src.hasOwnProperty(key)) target[key] = src[key];
    }
    return target;
  };
  jqStub.fn.extend = function (obj) {
    return jqStub.extend(jqStub.fn, obj);
  };
  jqStub.noConflict = function () {
    return jqStub;
  };
  jqStub.ready = function (fn) {
    if (fn) fn(jqStub);
    return jqStub;
  };
  jqStub.each = function (obj, fn) {
    if (Array.isArray(obj))
      for (var i = 0; i < obj.length; i++) fn.call(obj[i], i, obj[i]);
    else
      for (var k in obj) if (obj.hasOwnProperty(k)) fn.call(obj[k], k, obj[k]);
    return obj;
  };
  jqStub.map = function () {
    return [];
  };
  jqStub.grep = function () {
    return [];
  };
  jqStub.inArray = function (v, arr) {
    return arr ? arr.indexOf(v) : -1;
  };
  jqStub.isFunction = function (f) {
    return typeof f === "function";
  };
  jqStub.isArray = Array.isArray;
  jqStub.isPlainObject = function (o) {
    return typeof o === "object" && o !== null && o.constructor === Object;
  };
  jqStub.isEmptyObject = function (o) {
    for (var k in o) return false;
    return true;
  };
  jqStub.isNumeric = function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  };
  jqStub.type = function (o) {
    return typeof o;
  };
  jqStub.trim = function (s) {
    return s ? s.trim() : "";
  };
  jqStub.noop = function () {};
  jqStub.now = Date.now;
  jqStub.proxy = function (fn, ctx) {
    return fn.bind(ctx);
  };
  jqStub.Callbacks = function () {
    var list = [];
    var self = {
      add: function (fn) {
        list.push(fn);
        return self;
      },
      remove: function () {
        return self;
      },
      fire: function () {
        for (var i = 0; i < list.length; i++) list[i].apply(null, arguments);
        return self;
      },
      empty: function () {
        list = [];
        return self;
      },
      has: function () {
        return list.length > 0;
      },
    };
    return self;
  };
  jqStub.Deferred = function () {
    var cbs = { done: [], fail: [], always: [] },
      state = "pending",
      val;
    var d = {
      state: function () {
        return state;
      },
      resolve: function () {
        state = "resolved";
        val = arguments;
        cbs.done.forEach(function (f) {
          f.apply(null, val);
        });
        cbs.always.forEach(function (f) {
          f.apply(null, val);
        });
        return d;
      },
      reject: function () {
        state = "rejected";
        val = arguments;
        cbs.fail.forEach(function (f) {
          f.apply(null, val);
        });
        cbs.always.forEach(function (f) {
          f.apply(null, val);
        });
        return d;
      },
      done: function (fn) {
        if (fn) {
          if (state === "resolved") fn.apply(null, val);
          else cbs.done.push(fn);
        }
        return d;
      },
      fail: function (fn) {
        if (fn) {
          if (state === "rejected") fn.apply(null, val);
          else cbs.fail.push(fn);
        }
        return d;
      },
      always: function (fn) {
        if (fn) {
          if (state !== "pending") fn.apply(null, val);
          else cbs.always.push(fn);
        }
        return d;
      },
      then: function (done, fail) {
        if (done) d.done(done);
        if (fail) d.fail(fail);
        return d;
      },
      promise: function () {
        return d;
      },
    };
    d.notify = d.progress = function () {
      return d;
    };
    return d;
  };
  jqStub.when = function () {
    var d = jqStub.Deferred();
    d.resolve();
    return d.promise();
  };
  jqStub.ajax =
    jqStub.get =
    jqStub.post =
    jqStub.getJSON =
    jqStub.getScript =
      function () {
        return jqStub.Deferred().resolve().promise();
      };
  jqStub.event = { special: {} };
  jqStub.expr = {
    ":": {},
    pseudos: {},
    createPseudo: function () {
      return jqStub.noop;
    },
  };
  jqStub.cssHooks = {};
  jqStub.easing = {
    linear: function (p) {
      return p;
    },
    swing: function (p) {
      return 0.5 - Math.cos(p * Math.PI) / 2;
    },
  };
  jqStub.support = {};
  jqStub.contains = function (a, b) {
    return a !== b && (a.contains ? a.contains(b) : false);
  };
  jqStub.parseHTML = function () {
    return [];
  };
  jqStub.parseJSON = JSON.parse;
  jqStub.parseXML = function () {
    return null;
  };
  jqStub.data = function () {
    return undefined;
  };
  jqStub.removeData = jqStub.noop;
  jqStub._jqStub = true; // Flag to detect stub is active

  window.jQuery = window.$ = jqStub;
  console.warn(
    "[jquery-stub] jQuery failed to load. Running with no-op stub — interactive features disabled.",
  );
})();
